
  Vue.component('memo-add-button', {
    props: {
      curriculumId: { type: Number, default: 0 },
      direction: { type: String, default: 'left' },
      fetchLists: { type: Boolean, default: false },
      isFixed: { type: Boolean, default: false }
    },
    data() {
      return {
        showMemo: false,
        value: '',
        selectedMemo: 0,
        clickX: 0,
        clickY: 0
      }
    },
    pinia: Vue.pinia,
    template: '#memo-add-button',
    computed: {
      ...Pinia.mapState(useCurriculumMemosStore, {
        loading: store => store.loading,
        curriculaMemos: store => store.curriculaMemos || []
      }),
      isPinned() {
        return this.curriculaMemos ? this.curriculaMemos.hasOwnProperty(this.curriculumId) : false
      },
      memos() {
        return this.curriculaMemos[this.curriculumId] || [{}]
      },
      dropdownDirectionClass() {
        return `drop${this.direction}`
      },
      memo() {
        const idx = this.selectedMemo > this.memos.length - 1 ? this.memos.length - 1 : this.selectedMemo
        return this.memos[idx]
      },
      calcSelectedMemo() {
        return this.selectedMemo > this.memos.length - 1 ? this.memos.length - 1 : this.selectedMemo
      },
      fixedStyle() {
        return {
          position: 'fixed',
          left: `${this.clickX + 340}px`,
          top: `${this.clickY - 36}px`
        }
      }
    },
    watch: {},
    methods: {
      // seekerListsStore actions
      ...Pinia.mapActions(useCurriculumMemosStore, ['saveUpdateMemo', 'deleteMemo']),
      cleanMemos() {
        const idxToRemove = this.memos.findIndex(item => item.Id === -1)
        if (idxToRemove !== -1) {
          this.memos.splice(idxToRemove, 1)
        }
      },
      toggleMemo(event) {
        if (event) {
          const rect = event.target.getBoundingClientRect()
          this.clickX = rect.right
          this.clickY = rect.top
        }
        this.cleanMemos()
        this.showMemo = !this.showMemo
      },
      selectMemo(index) {
        this.selectedMemo = index
      },
      saveMemo(id, curriculumId, text, style, title) {
        this.saveUpdateMemo(id, curriculumId, text, style, title)
      },
      newMemo() {
        this.memos.push({ Id: -1, Text: '', CreateDate: moment().format('YYYY-MM-DDTHH:mm:ss') })
        this.selectedMemo = this.memos.length - 1
      },
      uniqueKey(id) {
        return `${this.curriculumId}${id}${moment().format('HHmmss')}`
      }
    },
    mounted() {
      if (this.fetchLists) {
        this.refreshSeekerLists().then(() => this.fetchSelectedListsByCurriculaIds([this.curriculumId]))
      }
    }
  })
